export const SELECT_PROJECT_LIST_REQUEST = 'SELECT_PROJECT_LIST_REQUEST'
export const SELECT_PROJECT_LIST_SUCCESS = 'SELECT_PROJECT_LIST_SUCCESS'
export const SELECT_PROJECT_LIST_FALUIRE = 'SELECT_PROJECT_LIST_FALUIRE'
